import { BloodworkAnalysis, CustomTextMarker, Section } from '../models';

/**
 * The text-result markers belonging to one RENDERED section.
 *
 * A section is identified by the same two values everywhere it is drawn: the
 * Section enum, plus — for the practitioner's own sections, which all render as
 * Section.CUSTOM_MARKERS — the name they gave it. Resolving from those two here
 * is what lets the screen (tabs-component) and the PDF (pdf-section) each ask
 * the question locally, instead of a third marker list being threaded down
 * through eighteen call sites in bloodwork-test-analysis.tsx and again in
 * bloodwork-analysis-pdf.tsx. Two files asking one function is also the only
 * arrangement in which the screen and the client's PDF cannot disagree about
 * which section a marker printed in.
 *
 * The three-way split (shipped section / practitioner's section / appendix) is
 * decided inside BloodworkAnalysis, where the empty-target guard lives, so this
 * is a router and not a second copy of the placement rules.
 */
export function sectionTextMarkers(
  bloodworkAnalysis: BloodworkAnalysis | undefined,
  section: Section,
  practitionerSectionName?: string,
): CustomTextMarker[] {
  if (!bloodworkAnalysis) {
    return [];
  }
  if (section === Section.CUSTOM_MARKERS) {
    return practitionerSectionName
      ? bloodworkAnalysis.getPractitionerSectionTextMarkers(
          practitionerSectionName,
        )
      : bloodworkAnalysis.getCustomTextMarkers();
  }
  return bloodworkAnalysis.getSectionTextMarkers(section);
}
